// FormatDate.js
import { ADToBS, BSToAD } from 'bikram-sambat-js';

export function convertToNepaliDate(inputDate) {
  let dateStr;

  // Normalize input
  if (inputDate instanceof Date) {
    const year = inputDate.getFullYear();
    const month = String(inputDate.getMonth() + 1).padStart(2, '0');
    const day = String(inputDate.getDate()).padStart(2, '0');
    dateStr = `${year}-${month}-${day}`;
  } else if (typeof inputDate === 'string') {
    const dateRegex = /^\d{4}-\d{2}-\d{2}$/;
    if (!dateRegex.test(inputDate)) {
      console.error('Invalid date format:', inputDate);
      return 'Invalid Date';
    }
    dateStr = inputDate.trim(); // Remove any whitespace
  } else {
    return 'Invalid Date';
  }

  try {
    const bsDate = ADToBS(dateStr);
    // Don't add template literal - BSToAD already returns a string
    return bsDate;
  } catch (error) {
    console.error('Error converting to Nepali date:', error);
    return 'Invalid Date';
  }
}

export function convertToEnglishDate(inputDate) {
  let dateStr;

  // Normalize input
  if (typeof inputDate === 'string') {
    const dateRegex = /^\d{4}-\d{2}-\d{2}$/;
    if (!dateRegex.test(inputDate)) {
      console.error('Invalid date format:', inputDate);
      return 'Invalid Date';
    }
    dateStr = inputDate.trim(); // Remove any whitespace
  } else {
    return 'Invalid Date';
  }

  try {
    const adDate = BSToAD(dateStr);
    // Don't add template literal - BSToAD already returns a string
    return adDate;
  } catch (error) {
    console.error('Error converting to English date:', error);
    return 'Invalid Date';
  }
}